export default {
  /**
   * 商品分類条件の標準フォーマット
   */
  get() {
    return {
      /**
       * 企業コード
       */
      company: undefined,

      base: {
        /**
         * @see store.js
         */
        key: new Date().getTime().toString(),
        /**
         * 選択モード（商品:item / 分類:category）
         */
        selectMode: 'category',
        /**
         * 選択分類（最下層）一覧
         */
        categories: [],
        /**
         * 選択商品一覧
         */
        items: [],
        /**
         * リソースID（商品一覧）
         */
        itemGroupId: undefined,
        /**
         * 入力エラー
         */
        errors: [],
      },
      compare: {
        /**
         * @see store.js
         */
        key: new Date().getTime().toString(),
        /**
         * 選択モード（商品:item / 分類:category）
         */
        selectMode: 'category',
        /**
         * 選択分類（最下層）一覧
         */
        categories: [],
        /**
         * 選択商品一覧
         */
        items: [],
        /**
         * リソースID（商品一覧）
         */
        itemGroupId: undefined,
        /**
         * 入力エラー
         */
        errors: [],
      },
      errors: [],
    }
  },
  /**
   * 分析APIで使用する期間のフォーマットに変換する
   */
  mapToApiPayload(item) {
    let base, compare

    if (item.base.selectMode === 'item') {
      base = {
        company: item.company,
        items: item.base.items ? item.base.items.map(i => i.code) : [],
        itemGroupId: item.base.itemGroupId,
      }
    } else if (item.base.selectMode === 'category') {
      base = {
        company: item.company,
        categories: item.base.categories,
      }
    } else {
      throw new Error(`unknown item select mode: ${item.base.selectMode}`)
    }

    if (item.compare.selectMode === 'item') {
      compare = {
        company: item.company,
        items: item.compare.items ? item.compare.items.map(i => i.code) : [],
        itemGroupId: item.compare.itemGroupId,
      }
    } else if (item.compare.selectMode === 'category') {
      compare = {
        company: item.company,
        categories: item.compare.categories,
      }
    } else {
      throw new Error(`unknown item select mode: ${item.compare.selectMode}`)
    }

    return {
      company: item.company,
      base: base,
      compare: compare,
    }
  },
  /**
   * applyToに対してitemCompareを適用する
   */
  applyPayload(applyTo, itemCompare) {
    applyTo.base.key = new Date().getTime().toString()
    applyTo.compare.key = new Date().getTime().toString()
    // 対象/比較パターンに対して画面遷移することはないので、適用処理は必ず
    // このモデル形式をこのモデル形式に当てはめるだけ。
    applyTo.company = itemCompare.company
    applyTo.base.selectMode = itemCompare.base.selectMode
    applyTo.base.categories = itemCompare.base.categories
    applyTo.base.items = itemCompare.base.items
    applyTo.base.itemGroupId = itemCompare.base.itemGroupId
    applyTo.compare.selectMode = itemCompare.compare.selectMode
    applyTo.compare.categories = itemCompare.compare.categories
    applyTo.compare.items = itemCompare.compare.items
    applyTo.compare.itemGroupId = itemCompare.compare.itemGroupId
  },
}
